// extracted by mini-css-extract-plugin
module.exports = {"contentsidebar":"contentsidebar_contentsidebar__Of7aM","content":"contentsidebar_content__Ab6MS","sidebar":"contentsidebar_sidebar__zoLCK"};